'use strict';

angular.module('buyers')
.directive('pageHeader', ['$rootScope', 'appInfo', 'localstorage', function($rootScope, appInfo, localstorage) {
    return {
        templateUrl : "partials/page-header.html",
        restrict: 'E', // attribute
        scope: {
            'page': '='
        },
        link : function (scope, element, attrs) {
            
            // scope.showFoundationPopup = false;
            // if(typeof localstorage.get('foundationPopupShown') == 'undefined') {
            //     localstorage.set('foundationPopupShown', 'yes');
            //     scope.showFoundationPopup = true;
            // } 
            // else if(localstorage.get('foundationPopupShown') != 'yes') {
            //     localstorage.set('foundationPopupShown', 'yes');
            //     scope.showFoundationPopup = true;
            // }

            scope.showVasyPopup = false;
            if(typeof localstorage.get('vasyPopupShown') == 'undefined') {
                localstorage.set('vasyPopupShown', 'yes');
                scope.showVasyPopup = true;
            } 
            else if(localstorage.get('vasyPopupShown') != 'yes') {
                localstorage.set('vasyPopupShown', 'yes');
                scope.showVasyPopup = true;
            }

            scope.helpText = '';
            if(appInfo.pages[scope.page].helpText) {
                scope.helpText = appInfo.pages[scope.page].helpText;    
            }
            scope.pageTitle = appInfo.pages[scope.page].title;

            scope.$watch('page', function(newValue, oldValue) {
                scope.helpText = '';
                if(appInfo.pages[newValue].helpText) {
                    scope.helpText = appInfo.pages[newValue].helpText;    
                }
                scope.pageTitle = appInfo.pages[newValue].title;  
            });

            scope.showHelp = function() {
                 // scope.$apply(function () {
                   scope.showHelpInfo = true;
                // });
            }
        }
    };
}]);